import { AppBar, Avatar, Box, Button, ListItemButton, ListItemIcon, ListItemText, Stack, Tab, Tabs, TextField, Toolbar, Typography } from '@mui/material'
import { Link, useParams } from 'react-router-dom'
import React, { useEffect, useRef, useState } from 'react'
import { Bell, UserCircle } from '@phosphor-icons/react'
import NotificationsIcon from '@mui/icons-material/Notifications';
import './style.css'
import httpClient from '../../_util/api'
import StudentDetail from './StudentDetail'
import Dropdown from '../Dropdown'
import { useDispatch } from 'react-redux'
import { hideLoader } from '../../Store/mainSlice'
import CustomizedSnackbars from '../Snackbar/SnackBar'
import timelineIcon from '../../assets/images/TimelineIcon.jpg'
import Notifications from '../Notifications/Notification';
import Profile from '../Profile/Profile';

const Dashboard = (props) => {
    const { id } = useParams();
    const { CNICNo } = useParams();
    const role = localStorage.getItem('role')
    const { stdId } = useParams();
    const snackbar_Ref = useRef()
    const dispatch = useDispatch()
    // const [studentId,setStudentId] = useState()
    const [value, setValue] = React.useState(0);
    const [timelines, setTimelines] = useState([])
    const [studentData, setStudentData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        CNICNo: "",
        phoneNo_Mobile: "",
        institutionName: "",
        courseTitle: "",
        grade: "",
        status: "",
        thirdParty: "",
        profilePic: "",
    })

    const thirdParty = [
        'IFTA',
        'MAWA',
    ]

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleAutocompleteValue = (data, field) => {
        setStudentData((prevValue) => ({ ...prevValue, [field]: data }))
    }

    const getStudentDetailsByCNICNo = async () => {
        console.log("kdfhie id", id);

        const res = await httpClient.get(`/students/getStudentByCNICNo/${CNICNo}`).catch((error) => {
            snackbar_Ref.current.showMessage("error", error?.response.data.message, "", "i-chk-circle");
        })
        if (res?.status === 200) {
            setStudentData(res?.data[0])
        }
    }

    const getTimelines = async () => {
        const res = await httpClient.get(role === 'Student' ? `/timelines/getTimelinesByMonth_StudentView` : role == "al-kauser Admin" ? `/timelines/getTimelinesAlKauserAdminView/${CNICNo}` : role === "admin" ? `/timelines/getTimelines/${CNICNo}` : `/timelines/getTimelinesVendorView/${CNICNo}`).catch((error) => {
            console.log("error", error.message);
        })

        if (res?.status === 200) {
            setTimelines(res?.data)
        }
    }

    const saveHandler = async () => {
        const res = await httpClient.post(`/students/saveThirdPartyDetails/${CNICNo}`, studentData).catch((error) => {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("error", error?.response.data.message, "", "i-chk-circle");
        })

        if (res.status === 200) {
            dispatch(hideLoader())
            snackbar_Ref.current.showMessage("success", res.data.message, "", "i-chk-circle");
        }
    }

    const handleInputChange = (data, field, fieldType) => {
        const updatedValue = fieldType === 'number' ? parseFloat(data) : data;
        setStudentData((prevFormData) => ({ ...prevFormData, [field]: updatedValue }));
    };

    useEffect(() => {
        if (role === 'Student') {
            getStudentDetailsByCNICNo()
        }
        else {
            getStudentDetailsByCNICNo()
        }

        getTimelines()
    }, [])


    return (
        <>
            <AppBar sx={{
                backgroundColor: '#22663D'
            }}>
                <CustomizedSnackbars ref={snackbar_Ref} />
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-around'} sx={{ width: '100%' }}>
                    <Stack sx={{ width: '80%' }}>
                        <Typography sx={{ fontSize: "30px" }}>Al Kauser</Typography>
                    </Stack>
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{ width: '6%' }}>
                        <ListItemButton >
                            <ListItemIcon>
                                <Notifications />
                            </ListItemIcon>
                        </ListItemButton>

                        <ListItemButton >
                            <ListItemIcon>
                                <Profile />
                            </ListItemIcon>
                        </ListItemButton>
                    </Stack>
                </Stack>

            </AppBar >
            <Stack justifyContent={'space-around'} sx={{ width: '100%', marginTop: '45px', backgroundColor: '#FCF8ED' }}>
                <Typography sx={{ width: '16%', textAlign: 'center' }}>{props.title}</Typography>
            </Stack>

            <Stack alignItems={'center'} justifyContent={'center'} sx={{ width: '100%', height: '90.2vh', backgroundColor: '#22663D' }}>
                <Stack flexDirection={'row'} justifyContent={'space-between'} sx={{ width: '93%', height: '83vh', backgroundColor: '#22663D' }}>
                    <Stack alignItems={'center'} justifyContent={'space-around'} sx={{ width: '29%', height: '53vh', backgroundColor: 'white', borderRadius: '6px' }}>
                        {

                        }
                        <Stack flexDirection={'row'} alignItems={'space-between'} justifyContent={'space-between'} sx={{ width: '89%' }}>
                            {
                                studentData.profilePic ?
                                    (
                                        <img src={studentData.profilePic} style={{ width: "87px", height: '87px', borderRadius: '44px' }} />
                                    )
                                    : (
                                        <Avatar sx={{ width: '21%', height: '100%' }}>
                                        </Avatar>
                                    )
                            }
                            <Stack sx={{ width: '74%' }}>
                                <Typography>{studentData.firstName} {studentData.lastName}</Typography>
                                <Typography>{studentData.email}</Typography>
                                <Typography>{studentData.CNICNo}</Typography>
                            </Stack>
                        </Stack>

                        <Stack alignItems={'center'} justifyContent={'space-between'}>
                            <Stack flexDirection={'row'} alignItems={'space-between'} justifyContent={'space-around'} flexWrap={'wrap'} sx={{ width: '95%', height: '36vh' }}>
                                <Stack className='textField'>
                                    <Typography>Phone</Typography>
                                    <TextField
                                        id="standard-basic"
                                        variant="standard"
                                        value={studentData.phoneNo_Mobile}
                                    />
                                </Stack>

                                <Stack className='textField'>
                                    <Typography>Institution Name</Typography>
                                    <TextField
                                        id="standard-basic"
                                        variant="standard"
                                        value={studentData.institutionName} />
                                </Stack>

                                <Stack className='textField'>
                                    <Typography>Course Title</Typography>
                                    <TextField
                                        id="standard-basic"
                                        variant="standard"
                                        value={studentData.courseTitle}
                                    />
                                </Stack>

                                <Stack className='textField'>
                                    <Typography>Grade/Class</Typography>
                                    <TextField
                                        id="standard-basic"
                                        variant="standard"
                                        value={studentData.grade}
                                    // onChange={(e) => { handleInputChange(e.target.value, "grade", "text") }}
                                    />
                                </Stack>

                                {
                                    (role === 'vendor' || role === 'Student') ? (
                                        <Stack sx={{ width: '100%' }}>
                                            <Stack className='textField'>
                                                <Typography>Status</Typography>
                                                <TextField
                                                    id="standard-basic"
                                                    variant="standard"
                                                    value={studentData.status}
                                                    onChange={(e) => { handleInputChange(e.target.value, "status", "text") }}
                                                />
                                            </Stack>
                                        </Stack>
                                    ) : (
                                        <Stack className='textField'>
                                            <Typography>Status</Typography>
                                            <TextField
                                                id="standard-basic"
                                                variant="standard"
                                                value={studentData.status}
                                                onChange={(e) => { handleInputChange(e.target.value, "status", "text") }}
                                            />
                                        </Stack>
                                    )
                                }
                                {/* <Stack sx={{width:'100%'}}>
                                    <Stack className='textField'>
                                        <Typography>Status</Typography>
                                        <TextField
                                            id="standard-basic"
                                            variant="standard"
                                            value={studentData.status}
                                            onChange={(e) => { handleInputChange(e.target.value, "status", "text") }}
                                        />
                                    </Stack>
                                </Stack> */}


                                {
                                    (role === 'admin' || role === 'al-kauser Admin') && (
                                        <>
                                            <Stack className='textField'>
                                                <Typography>3rd Party</Typography>
                                                {
                                                    (role === 'admin' || role === 'al-kauser Admin')
                                                        ? (
                                                            <Dropdown value={studentData.thirdParty} options={thirdParty} origin="" onSelectValue={(data) => handleAutocompleteValue(data, 'thirdParty')} />
                                                        )
                                                        : (
                                                            // <TextField
                                                            //     id="standard-basic"
                                                            //     variant="standard"
                                                            //     value={studentData.thirdParty}
                                                            // />
                                                            <></>
                                                        )
                                                }
                                            </Stack>

                                            {/* {role === 'admin' && 
                                    ( */}
                                            <Stack sx={{ width: "97%" }}>
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: "#208146",
                                                        color: 'white',
                                                        width: '92px',
                                                        height: "5vh",
                                                        fontSize: '12px',
                                                        borderRadius: '12px',
                                                        "&:hover": {
                                                            backgroundColor: "#208146",
                                                        },
                                                    }}
                                                    onClick={saveHandler}
                                                >
                                                    Save
                                                </Button>
                                            </Stack>
                                            {/* )
                                } */}

                                        </>
                                    )
                                }
                            </Stack>
                        </Stack>

                    </Stack>


                    <Stack sx={{ width: '45%', height: '100%', backgroundColor: 'white', borderRadius: '6px' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="Application" />
                            <Tab label="Vendor Docs" />
                            {/* {
                                role === 'admin' && ( */}
                            <Tab label="Notes" />
                            {/* )
                            } */}
                            <Tab label="Attachments" />
                        </Tabs>
                        <Stack alignItems={'center'} sx={{ width: '100%', height: '88%', overflowY: 'auto', scrollbarWidth: 'none' }}>
                            <StudentDetail value={value} />
                        </Stack>
                    </Stack>

                    <Stack alignItems={'center'} justifyContent={'space-around'} sx={{ width: '25%', height: '100%', backgroundColor: 'white', borderRadius: '6px' }}>
                        <Box sx={{ width: '92%', fontSize: '18px' }}>Timelines</Box>
                        <Stack sx={{ width: '92%', height: '92%', border: '2px solid #EFEFEF', overflowY: 'auto' }}>
                            <Stack alignItems={'center'}>
                                {
                                    timelines.map((item) => {
                                        return (
                                            <>
                                                <Stack justifyContent={'center'} sx={{ width: '100%', backgroundColor: '#EFEFEF', fontSize: '17px' }}>{item.monthName}</Stack>
                                                <Stack sx={{ width: '98%' }}>
                                                    {
                                                        item.timelines.map((timeline) => {
                                                            return (
                                                                <Stack flexDirection={'row'}>
                                                                    <Stack
                                                                        sx={{ height: '12vh' }}
                                                                    >
                                                                        <img src={timelineIcon} style={{ width: '18px', height: '100%' }} />
                                                                    </Stack>
                                                                    <Stack justifyContent='space-between' sx={{ width: '100%', height: '66%' }}>
                                                                        <Stack flexDirection={'row'} alignItems={'space-between'} justifyContent={'space-between'} sx={{ width: '100%', height: "63%" }}>
                                                                            <Typography>{timeline.heading}</Typography>
                                                                            <Typography sx={{ fontSize: '13px' }}> {timeline.heading === 'Application Submitted' ? timeline.applicationSubmitDate : timeline.heading === 'Application Accepted' ? timeline.applicationApprovalDate : timeline.heading === 'Application Rejected' ? timeline.applicationRejectionDate : ""} | {timeline.heading === 'Application Submitted' ? timeline.applicationSubmitTime : timeline.heading === 'Application Accepted' ? timeline.applicationApprovalTime : timeline.heading === 'Application Rejected' ? timeline.applicationRejectionTime : ""}</Typography>
                                                                        </Stack>
                                                                        <Typography fontSize={'14px'}>{timeline.message}</Typography>
                                                                    </Stack>
                                                                </Stack>
                                                            )
                                                        })
                                                    }
                                                </Stack></>
                                        )
                                    })
                                }
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </>
    )
}

export default Dashboard